<template>
  <div :style="backgroundStyle" class="background-container">
    <!-- Slot for dynamic content -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DynamicBackground",
  props: {
    backgroundUrl: {
      type: String,
      required: false, // Background URL is optional
      default: null,
    },
    /* Empty by default. This used to be a placeholder example.com URL, so a
       position with no art fired a request that could never resolve. */
    defaultBackground: {
      type: String,
      required: false,
      default: "",
    },
    fit: {
      type: String,
      required: false,
      default: "cover",
      validator: (value) => ["cover", "contain"].includes(value),
    },
  },
  computed: {
    resolvedUrl() {
      return this.backgroundUrl || this.defaultBackground || "";
    },
    backgroundStyle() {
      if (!this.resolvedUrl) return {};
      /* API data going into a CSS grammar — a raw `")` would close the url()
         and inject declarations. */
      const safe = this.resolvedUrl.replace(/["'()\\\s]/g, encodeURIComponent);
      return {
        backgroundImage: `url("${safe}")`,
        backgroundSize: this.fit,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      };
    },
  },
};
</script>

<style scoped>
.background-container {
  transition: background 0.3s ease-in-out;
  width: 100%;
  height: 100%;
}
</style>
